import React, { useContext, useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { Link } from 'react-router-dom';
import { AppContext } from '../../../AppContext';

const Testimonials = () => {
    const { appState } = useContext(AppContext);
    const {
        sectionTitle,
        sectionDescription,
        clientTitle,
        clientDescription,
        items,
        clients
    } = appState.testimonials || {};

    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    const slider1 = useRef();
    const slider2 = useRef();

    useEffect(() => {
        setNav1(slider1.current);
        setNav2(slider2.current);
    }, []);

    const navSettings = {
        infinite: true,
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
        centerMode: true,
        centerPadding: '0px',
        focusOnSelect: true,
        responsive: [
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                    arrows: false
                }
            }
        ]
    };

    const contentSettings = {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        draggable: false,
        dots: false,
        vertical: true
    };

    if (!items?.[0]) {
        return
    }


    return (
        <section className="section-padding findrate-bottom">
            <div className="container">
                <div className="row">
                    {/* Testimonials */}
                    <div className="col-lg-6">
                        <div className="testimonials-box mb-md-80">
                            <div className="section-header">
                                <div className="section-heading">
                                    <h3 className="text-custom-black fw-700">{sectionTitle}</h3>
                                </div>
                                <div className="section-description">
                                    <p className="text-light-white">{sectionDescription}</p>
                                </div>
                            </div>
                            <div className="testimonials-wrapper">
                                <div className="col-12">
                                    <Slider
                                        asNavFor={nav2}
                                        ref={slider1}
                                        {...navSettings}
                                        className="testimonial-nav row mb-xl-40"
                                    >
                                        {items.map((item, i) => (
                                            <div key={i} className="slide-item col-12">
                                                <div className="testimonials-author">
                                                    <Link to="#">
                                                        <img
                                                            src={item.image}
                                                            className="image-fit"
                                                            alt={item.name}
                                                        />
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                    <Slider
                                        asNavFor={nav1}
                                        ref={slider2}
                                        {...contentSettings}
                                        className="testimonial-for row"
                                    >
                                        {items.map((item, i) => (
                                            <div key={i} className="slide-item col-12">
                                                <div className="testimonials-inner">
                                                    <div className="testimonial-content">
                                                        <h4 className="text-custom-blue fw-700 fs-20">{item.title}</h4>
                                                        <p className="text-light-white mb-xl-20">{item.comment}</p>
                                                        <p className="text-custom-black fw-700">
                                                            <strong>{item.name}<br />
                                                                <span className="text-light-blue fw-500">{item.designation}</span>
                                                            </strong>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Clients */}
                    <div className="col-lg-6">
                        <div className="clients-box">
                            <div className="section-header">
                                <div className="section-heading">
                                    <h3 className="text-custom-black fw-700">{clientTitle}</h3>
                                </div>
                                <div className="section-description">
                                    <p className="text-light-white">{clientDescription}</p>
                                </div>
                            </div>
                            <div className="clients-wrapper">
                                {clients.map((client, i) => (
                                    <div key={i} className="client-box">
                                        <div className="client-item">
                                            <Link to="#">
                                                <img
                                                    src={client.image}
                                                    className="image-fit"
                                                    alt={client.companyname}
                                                />
                                            </Link>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;
